import React, { ReactNode } from "react";
import FormControlLabel, { FormControlLabelProps } from "@mui/material/FormControlLabel";
import Radio, { RadioProps } from "@mui/material/Radio";
import { useField } from "formik";

export interface RadioFormikProps
  extends Omit<RadioProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  status?: boolean;
  value?: any;
}

const RadioField = ({
  name,
  label,
  value,
  status,
  labelPlacement,
  ...props
}: RadioFormikProps) => {
  const [field] = useField({ name, type: 'radio', value: value });

  return (
    <FormControlLabel
      control={
        <Radio
          {...field}
          value={value}
          checked={field.checked}
          disabled={status || props.readOnly}
          onChange={field.onChange}
          onBlur={field.onBlur}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default RadioField;
